import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../reducers/user/userSlice';
import privilegeReducer from '../reducers/privilege/privilegeSlice';
import stepperReducer from '../reducers/companyRegistrationStep/stepperSlice';
import selectedCompanyReducer from '../reducers/companyRegistrationStep/selectedCompanySlice';

export const store = configureStore({
    reducer: {
        user: userReducer,
        privilege: privilegeReducer,
        stepper: stepperReducer,
        selectedCompany: selectedCompanyReducer
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;